import React, { useState, useEffect } from "react";

import Web3 from "web3";
import Market from "../../abi/marketplace.json";
import { Link } from "react-router-dom";
import copy from "copy-to-clipboard";
// Stylesheet
import "./SingleNFT.css";

// Assets
import ethereum from "../../assets/ethereum.png";
import polygon from "../../assets/matic.svg";

import ls from "localstorage-slim";

// Components
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Price from "../createNFT/sections/price/Price";

// Material UI Icons
import { Menu, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";

import { nftmarketaddress, nftaddress} from "../../config/polygon.js"
import { ethnftmarketaddress, ethnftaddress} from "../../config/ethereum.js"

import { ClipLoader } from "react-spinners";

import {
  FacebookShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
} from "react-share";
import { SiIpfs } from "react-icons/si";

import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import PreloaderInner from "./../../components/preloader/loader";
import firebase from "./../../firebase";
import { useDispatch, useSelector } from "react-redux";
import { authFeatureKey } from "../../store/featureKeys";
import * as authActions from "../../store/actions/authActions";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Popup from 'reactjs-popup';
import { Influencer } from "../createNFT/sections/influencer/Influencer";
import TransactionTable from "../../components/transactions/TransactionTable";
import InfluencerTable from "../../components/influencer/InfluencerTable";
import { maticToWei } from "../utils/PriceUtils";

const web3 = new Web3(window.ethereum);

function SingleNFT() {
  let location = window.location.href;
  let { ipfsHash } = useParams();
  let shareUrl = `${location}`;
  const [NFTDetail, setNFTDetail] = useState({});

  const [display, setDisplay] = useState("arrow");
  const [align, setAlign] = useState("center");
  const [position, setPosition] = useState("anchor");
  const [viewScroll, setViewScroll] = useState("auto");
  const [direction, setDirection] = useState("left");
  const [spinner, setSpinner] = React.useState(false);
  const [loaderText, setLoaderText] = useState("loading...");
  const [views, setViews] = useState(0);
  const [likes, setLikes] = useState(0);
  const [username, setUserName] = useState("");
  const [owner,setOwner] = useState("");
  const [ownerAddress,setOwnerAddress] = useState("");
  const [loader, setLoader] = useState(true);
  const [creatorAddress, setCreatorAddress] = useState("");
  const [ownerUsername, setOwnerUsername] = useState("");
  const [userAddress, setUserAddress] = useState("");
  const [account, setAccount] = React.useState("");
  const [inf, setInfluencer] = useState([]);
  const [sellingPrice, setSellingPrice] = useState(0);
  const [refreshToken, setRefreshToken] = useState(0);
  const [resellPrice, setResellPrice] = useState("");
  const [isResellSubmited, setResellSubmited] = useState(false);
  const [promoBudget, setPromoBudget] = useState("");
  const auth = useSelector((state) => {
    return state[authFeatureKey];
  });
  let currentUser = auth.currentUser;

  const isOwner = () => {
    if (currentUser === ownerAddress) {
      return true;
    }
    return false;
  };
  React.useEffect(async () => {
    const { ethereum } = window;
    const web3 = new Web3(ethereum);
    const a = await web3.eth.getAccounts();
    if (a != account) {
      setAccount(a);
    }
  }, [account]);

  useEffect(() => {
    fetchData();
  }, [refreshToken]);
  const fetchData = async () => {
    firebase
      .firestore()
      .collection("NFTDataModel")
      .where("ipfsHash", "==", ipfsHash)
      .limit(1)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          let detail = doc.data();
          detail.docID = doc.id;
          setNFTDetail(detail);
          setViews(detail.views);
          setLikes(detail.likes);
          setOwnerAddress(detail.ownerAddress);
          setCreatorAddress(detail.creatorAddress);
          let updatedObj = { ...detail };
          updatedObj.views = detail.views + 1;
          updatedObj.score = detail.score + 1;
          doc.ref.update(updatedObj);
        });
      });
  };
  async function setNftSold(nft, useraddr) {
    await firebase
      .firestore()
      .collection("NFTDataModel")
      .doc(nft.docID)
      .update({
        sold: true,
        ownerAddress: useraddr,
      });
  }

  async function nftPromotionListUpdate(nft) {
    await firebase
      .firestore()
      .collection("NFTPromotionList")
      .limit(1)
      .where("nftid", "==", nft.docID)
      .where("promotedBy", "==", ownerAddress)
      .where("listed", "==", true)
      .orderBy("createdAt", "desc")
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach((doc) => {
          var detail = doc.data();
          let updatedObj = { ...detail };
          updatedObj.listed = false;
          doc.ref.update(updatedObj);
        });
      });
  }

  async function setNftListed(nft, listed) {
    await firebase
      .firestore()
      .collection("NFTDataModel")
      .doc(nft.docID)
      .update({
        price: nft.price,
        listed: listed
      });
    
    if (!listed) {
      await nftPromotionListUpdate(nft);
    }
  }

  async function addTransferTransaction(nft, useraddr, txnHash) {
    await firebase
      .firestore()
      .collection("NFTTransactionHistory")
      .add({
        createdAt: new Date(),
        nftid: String(nft.docID),
        from: nft.ownerAddress,
        to: useraddr,
        price: nft.price,
        chain: nft.chain,
        txnHash: txnHash,
        txnType: "TRANSFER"
      })
      .catch((error) => {
        console.log("TXN History Error", error);
      });
  }

  async function addListingTransaction(nft, txnHash, delisted) {
    await firebase
      .firestore()
      .collection("NFTTransactionHistory")
      .add({
        createdAt: new Date(),
        nftid: String(nft.docID),
        from: nft.ownerAddress,
        to: "",
        price: nft.price,
        chain: nft.chain,
        txnHash: txnHash,
        txnType: delisted ? "DELISTED" : "LISTED"
      })
      .catch((error) => {
        console.log("TXN History Error", error);
      });
  }

  function updateNFTDetailPrice(updatedPrice) {
    NFTDetail.price = updatedPrice;
    setNFTDetail(NFTDetail);
  }
  
  useEffect(() => {
    if (creatorAddress) {
      firebase
        .firestore()
        .collection("UserDataModel")
        .limit(2)
        .where("walletAddress", "in", [`${creatorAddress}`,`${ownerAddress}`])
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            if (doc.data().walletAddress === creatorAddress) {
              const userDetail = doc.data();
              setUserAddress(userDetail.walletAddress);
              if (userDetail.username) {
                setUserName(userDetail.username);
                setLoader(false);
              }
            }
            if (doc.data().walletAddress === ownerAddress) {
              const ownerDetail = doc.data()
              if (ownerDetail.username) {
                setOwnerUsername(ownerDetail.username);
                setLoader(false);
              }
            }
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
          setLoader(false);
        });
    }
  }, [creatorAddress,ownerAddress]);

  async function executeBuyNft(Marketcontract, currentNft, account, price, nftaddress) {
    try {
      const transaction = await Marketcontract.methods
        .createMarketSale(
          nftaddress,
          currentNft.itemid
        )
        .send({ from: `${account[0]}`, value: price });
      const nftSoldAwait = await setNftSold(currentNft, user.walletAddress);
      const nftlistedAwait = await setNftListed(currentNft, false);
      const nftTransactionAwait = await addTransferTransaction(currentNft, user.walletAddress, transaction.transactionHash);
      setRefreshToken(refreshToken => refreshToken + 1);
      setLoader(false);
      setLoaderText("Loading...");
    } catch (err) {
      console.log(err);
      setRefreshToken(refreshToken => refreshToken + 1);
      setLoader(false);
    }
  }

  const buyNFT = async (currentNft) => {
    try {
      setLoader(true);
      setLoaderText("Buying NFT...");
      if (
        currentNft.chain === "Ethereum" &&
        window.ethereum.networkVersion === "4"
      ) {
        const account = await web3.eth.getAccounts();
        const Marketcontract = new web3.eth.Contract(
          Market,
          ethnftmarketaddress // change mainnet market address over here
        );
        const price = web3.utils.toWei(`${currentNft.price}`, "ether");
        await executeBuyNft(Marketcontract, currentNft, account, price, ethnftaddress);
      } else if (
        currentNft.chain === "Polygon" &&
        window.ethereum.networkVersion === "80001" // change chainid for mainnet over here
      ) {
        const account = await web3.eth.getAccounts();
        const Marketcontractpoly = new web3.eth.Contract(
          Market,
          nftmarketaddress
        );
        const price = maticToWei(currentNft.price);
        await executeBuyNft(Marketcontractpoly, currentNft, account, price, nftaddress);
      } else {
        alert(
          "Wrong network. Please connect your wallet to the right network."
        );
        setLoader(false);
        setLoaderText("Loading...");
      }
      // loadNFTs()
    } catch (er) {
      console.log(er);
      setRefreshToken(refreshToken => refreshToken + 1);
      setLoader(false);
      setLoaderText("Loading...");
    }
  };

  async function executeResellNft(Marketcontract, currentNft, price, account, nftaddress) {
    try {
      const transaction = await Marketcontract.methods
        .makeMarketItemForResale(
          nftaddress,
          currentNft.itemid,
          price
        )
        .send({ from: `${account[0]}` });
      console.log("TXN", transaction);
      const nftDetailPriceAwait = await updateNFTDetailPrice(resellPrice);
      console.log("NFT Detail Price Update");
      const nftListedAwait = await  setNftListed(currentNft, true);
      console.log("NFT Listed");
      const nftListingTransactionAwait = await addListingTransaction(currentNft, transaction.transactionHash, false);
      console.log("NFT Txn listed");
      setRefreshToken(refreshToken => refreshToken + 1);
      setLoader(false);
    } catch (err) {
      console.log(err);
      setRefreshToken(refreshToken => refreshToken + 1);
      setLoader(false);
    }
  }

  const resellNFT = async (currentNft) => {
    setResellSubmited(true);
    try {
      setLoader(true);
      if (
        currentNft.chain === "Ethereum" &&
        window.ethereum.networkVersion === "4"
      ) {
        const account = await web3.eth.getAccounts();
        const Marketcontract = new web3.eth.Contract(
          Market,
          ethnftmarketaddress // change mainnet market address over here
        );
        
        const price = web3.utils.toWei(`${resellPrice}`, "ether");
        await executeResellNft(Marketcontract, currentNft, price, account, ethnftaddress);
      }  else if (
        currentNft.chain === "Polygon" &&
        window.ethereum.networkVersion === "80001" // change chainid for mainnet over here
      ) {
        const account = await web3.eth.getAccounts();
        const Marketcontract = new web3.eth.Contract(
          Market,
          nftmarketaddress // change mainnet market address over here
        );
        
        const price = maticToWei(resellPrice);
        await executeResellNft(Marketcontract, currentNft, price, account, nftaddress);
      } else {
        alert(
          "Wrong network. Please connect your wallet to the right network."
        );
        setLoader(false);
      }
      // loadNFTs()
    } catch (er) {
      console.log(er);
      setRefreshToken(refreshToken => refreshToken + 1);
      setLoader(false);
    }
  };

  async function executeDelistNft(Marketcontract, currentNft, account, nftContractAddress) {
    try {
      const transaction = await Marketcontract.methods
        .cancelMarketItem(
          nftContractAddress,
          currentNft.itemid
        )
        .send({ from: `${account[0]}` });
      console.log("Delist TXN", transaction);
      const nftListedAwait = await setNftListed(currentNft, false);
      console.log("NFT DeListed");
      const nftListingTransactionAwait = await addListingTransaction(NFTDetail, transaction.transactionHash, true);
      console.log("NFT Delisted");
      setRefreshToken(refreshToken => refreshToken + 1);
      setLoader(false);
    } catch (err) {
      console.log(err);
      setRefreshToken(refreshToken => refreshToken + 1);
      setLoader(false);
    }
  }

  const delistNFT = async (currentNft) => {
    try {
      setLoader(true);
      if (
        currentNft.chain === "Ethereum" &&
        window.ethereum.networkVersion === "4"
      ) {
        const account = await web3.eth.getAccounts();
        const Marketcontract = new web3.eth.Contract(
          Market,
          ethnftmarketaddress // change mainnet market address over here
        );
        await executeDelistNft(Marketcontract, currentNft, account, ethnftaddress);
      }  else if (
        currentNft.chain === "Polygon" &&
        window.ethereum.networkVersion === "80001" // change chainid for mainnet over here
      ) {
        const account = await web3.eth.getAccounts();
        const Marketcontract = new web3.eth.Contract(
          Market,
          nftmarketaddress // change mainnet market address over here
        );
        await executeDelistNft(Marketcontract, currentNft, account, nftaddress);
      } else {
        alert(
          "Wrong network. Please connect your wallet to the right network."
        );
        setLoader(false);
      }
    } catch (er) {
      console.log(er);
      setRefreshToken(refreshToken => refreshToken + 1);
      setLoader(false);
    }
  };

  const promoteNFTs = async (currentNft) => {
    let influencerList = [];
    inf.forEach((influencer) => {
      var document = {};
      document.handle = {};
      document.handle.username = influencer.username;
      document.handle.twitter = "https://twitter.com/" + influencer.username.substring(1);
      document.status = "REQUESTED";
      influencerList.push(document);
    });

    await nftPromotionListUpdate(currentNft)
      .then ((querySnapshot) => {
        firebase
          .firestore()
          .collection("NFTPromotionList")
          .add({
            createdAt: new Date(),
            nftid: String(currentNft.docID),
            promotedBy: currentNft.ownerAddress,
            maximumPricePerTweet: promoBudget,
            influencers: influencerList,
            listed: true
          })
          .catch((error) => {
            console.log("NFT Promotion List Error", error);
          });
      });
      setRefreshToken(refreshToken => refreshToken + 1);
  }

  const stopMovie = (e) => {
    e.target.pause();
  };

  const playMovie = (e) => {
    e.target.play();
  };
  let dispatch = useDispatch();
  const menus = ["left"];
  const { isConnected, user } = useSelector((state) => {
    return state[authFeatureKey];
  });
  const isNFTLiked = (docId) => {
    if (isConnected) {
      const isLiked = user.likedNft.find((nft) => nft === docId);
      if (isLiked) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  let likeNft = (docID, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isConnected) {
      if (isNFTLiked(docID)) {
        setSpinner(true);
        setTimeout(() => {
          setSpinner(false);
          setLikes(likes - 1);
        }, 2000);
        dispatch(authActions.dislikeCard(docID, currentUser));
      } else {
        setSpinner(true);
        setTimeout(() => {
          setSpinner(false);
          setLikes(likes + 1);
        }, 2000);
        dispatch(authActions.likeCard(docID, currentUser));
      }
    }
  };
  
  return (
    <section className="singlenft-wrapper">
      {loader && <PreloaderInner loaderText={loaderText} />}
      <div className="singlenft ">
        <div className="cards nft-cards-singlefit">
          <div className="card nft-card-singlenft">
            {NFTDetail &&
            NFTDetail.imageUrl &&
            NFTDetail.imageUrl.indexOf("mp4") > -1 ? (
              <video
                onMouseOver={playMovie}
                onMouseOut={stopMovie}
                preload="none"
                className="nftImg-singlenft"
                src={NFTDetail.imageUrl}
                loop
              >
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={NFTDetail && NFTDetail.imageUrl}
                alt="Card"
                className="nftImg-singlenft"
              />
            )}
          </div>
        </div>
        <div className="singlenft-details ">
          <h2>{NFTDetail && NFTDetail.name}</h2>
          <p class="singlenftText">{NFTDetail && NFTDetail.description}</p>
          <p className="cLine">
            <span style={{ color: "white" }}>
              created by{" "}
              <Link to={`/profile/${username}`}>
                <span className="yellow">@{username}</span>
              </Link>
            </span>

            <span style={{ color: "white" }}>
              owned by{" "}
              <Link to={`/profile/${ownerUsername}`}>
                <span className="yellow">@{ownerUsername}</span>
              </Link>
            </span>
            <span style={{ color: "white" }}>
              <Stack direction="row" alignItems="center" gap={1}>
                <RemoveRedEyeOutlinedIcon style={{ fontSize: "15px" }} />
                <Typography style={{ fontSize: "13px" }} variant="body1">
                  {views}
                </Typography>
                <FavoriteBorderIcon style={{ fontSize: "15px" }} />
                <Typography style={{ fontSize: "13px" }} variant="body1">
                  {likes}
                </Typography>
              </Stack>
            </span>
          </p>
          <div className="tags">
            {NFTDetail &&
              NFTDetail.tags &&
              NFTDetail.tags.map((data) => <p className="tag">{data}</p>)}
          </div>
          <div className="singlenft-price">
            {NFTDetail.chain === "Ethereum" ? (
              <img src={ethereum} alt="ethereum" />
            ) : (
              <img src={polygon} alt="polygon" />
            )}
            <h3>{NFTDetail && NFTDetail.price}</h3>
            {NFTDetail && NFTDetail.price && (
              <p>
                ($
                {NFTDetail.chain === "Ethereum"
                  ? (
                      (NFTDetail.price - NFTDetail.price * (2.5 / 100)) *
                      ls.get("eth-usd")
                    ).toFixed(2)
                  : (
                      (NFTDetail.price - NFTDetail.price * (2.5 / 100)) *
                      ls.get("matic-usd")
                    ).toFixed(2)}
                )
              </p>
            )}
          </div>
          <div class="buttons-span">
            {NFTDetail.listed && !isOwner() && (
              <div className="singlenft-buttons">
                <button
                  onClick={() => {
                    buyNFT(NFTDetail);
                  }}
                  className="button-white"
                >
                  Buy Now
                </button>
              </div>
            )}
            {NFTDetail.listed && isOwner() && (
              <div className="singlenft-buttons">
                <button
                  onClick={() => {
                    delistNFT(NFTDetail);
                  }}
                  className="button-white"
                >
                  DeList
                </button>
              </div>
            )}
            {NFTDetail.listed && isOwner() && (
              <div className="singlenft-buttons">
                  <Popup
                    trigger={<button className="button"> Promote </button>}
                    modal
                    nested
                  >
                    {close => (
                      <div className="modal modal-scroll modal-max-height">
                        <button className="close" onClick={close}>
                          &times;
                        </button>
                        <div className="header"> Promote your NFT </div>
                        <div className="content">
                          <div className="form-right">
                            <div className="budget-input">
                              <p className="modal-input-heading">
                                <span>Budget&nbsp;</span>
                                <span className="yellow modal-subtext" style={{ fontWeight: "lighter" }}>
                                  (Maximum USD$ per tweet)
                                </span>
                              </p>
                              <input
                                value={promoBudget}
                                type="text"
                                placeholder="$USD"
                                onChange={(e) => {
                                  console.log("==================BUDGET=========", e.target.value);
                                  setPromoBudget(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                          <Influencer setInfluencer={setInfluencer} inf={inf} />
                        </div>
                        <div className="actions">
                          <div className="singlenft-buttons">
                            <button
                              className="button-white"
                              onClick={() => {
                                promoteNFTs(NFTDetail);
                                close();
                              }}
                            >
                              Promote
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </Popup>
              </div>
            )}
            {!NFTDetail.listed && isOwner() && (
              <div className="singlenft-buttons">
                  <Popup
                    trigger={<button className="button"> List </button>}
                    modal
                    nested
                  >
                    {close => (
                      <div className="modal">
                        <button className="close" onClick={close}>
                          &times;
                        </button>
                        <div className="header"> List your NFT </div>
                        <div className="content">
                          <Price
                            isSubmited={isResellSubmited}
                            setPrice={setResellPrice}
                            price={resellPrice}
                            type={NFTDetail.chain}
                          />
                        </div>
                        <div className="actions">
                          <div className="singlenft-buttons">
                            <button
                              className="button-white"
                              onClick={() => {
                                resellNFT(NFTDetail);
                                close();
                              }}
                            >
                              List Now
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </Popup>
              </div>
            )}
          </div>
        </div>
        <div className="side-icons">
          {spinner ? (
            <div className="side-icon" style={{ padding: "15px" }}>
              <ClipLoader loading={spinner} color={"#d3aa4b"} size={18} />
            </div>
          ) : isNFTLiked(NFTDetail.docID) ? (
            <FavoriteIcon
              className="side-icon liked-heart-icon"
              style={{ padding: "16px 14px" }}
              onClick={likeNft.bind(this, NFTDetail.docID)}
            />
          ) : (
            <FavoriteBorderIcon
              className="side-icon "
              onClick={likeNft.bind(this, NFTDetail.docID)}
            />
          )}
          {NFTDetail.url && (
            <SendRoundedIcon
              className="side-icon"
              onClick={() => {
                window.location.href = `${NFTDetail.url}`;
              }}
            />
          )}
          <div>
            {menus.map((direction) => (
              <Menu
                menuButton={<ShareIcon className="side-icon" />}
                key={direction}
                direction={direction}
                align={align}
                position={position}
                viewScroll={viewScroll}
                arrow={display === "arrow"}
                offsetX={
                  display === "offset" &&
                  (direction === "left" || direction === "right")
                    ? 12
                    : 0
                }
                offsetY={
                  display === "offset" &&
                  (direction === "top" || direction === "bottom")
                    ? 12
                    : 0
                }
              >
                <MenuItem
                  onClick={(e) => {
                    copy(shareUrl);
                    toast.success("Link Copied Successfully");
                  }}
                >
                  <div className="option-container">
                    <div className="icon-box">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="size-of-icon"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z" />
                        <path d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z" />
                      </svg>
                    </div>
                    <div className="option-text">Copy Link</div>
                  </div>
                </MenuItem>
                <MenuItem>
                  <FacebookShareButton
                    url={shareUrl}
                    title={NFTDetail && NFTDetail.name}
                  >
                    <div className="option-container">
                      <div className="icon-box">
                        <FacebookIcon size={"1.5rem"} />
                      </div>
                      <div className="option-text">Share on Facebook</div>
                    </div>
                  </FacebookShareButton>
                </MenuItem>
                <MenuItem>
                  <TwitterShareButton
                    url={shareUrl}
                    title={NFTDetail && NFTDetail.name}
                  >
                    <div className="option-container">
                      <div className="icon-box">
                        <TwitterIcon size={"1.5rem"} />
                      </div>
                      <div className="option-text">Share on Twitter</div>
                    </div>
                  </TwitterShareButton>
                </MenuItem>
              </Menu>
            ))}
          </div>
          <SiIpfs
            className="side-icon"
            size={24}
            onClick={() => {
              window.location.href = `https://${NFTDetail.ipfsHash}.ipfs.dweb.link/metadata.json`;
            }}
          />
          <ReportProblemOutlinedIcon
            className="side-icon"
            onClick={() => {
              window.location.href = "mailto:support@loopgem.com";
            }}
          />
        </div>
      </div>
      {NFTDetail.listed && isOwner() && (
        <InfluencerTable className="tableContainer" nftid={NFTDetail.docID} ownerAddress={NFTDetail.ownerAddress} refreshToken={refreshToken} />
      )}
      <TransactionTable className="tableContainer" nftid={NFTDetail.docID} refreshToken={refreshToken} />
    </section>
  );
}

export default SingleNFT;

